// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__2y1_n","head":"Table_head__2e9R4","col":"Table_col__3kcMh"};